module.exports = __webpack_public_path__ + "img/box@2x.fb0a443d.png";